"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var defaultAvatar_png_1 = __importDefault(require("../../../assets/images/defaultAvatar.png"));
var components_1 = require("../../../common/components");
var common_1 = require("../../../common");
var App_1 = require("../../App");
var styles = __importStar(require("./ChatHeader.module.css"));
var ChatHeader = function () {
    var _a, _b, _c, _d;
    var intl = (0, react_intl_1.useIntl)();
    var _e = (0, react_1.useContext)(App_1.WidgetContext), widgetSettings = _e.widgetSettings, socketService = _e.socketService;
    var _f = (0, react_1.useState)((_b = (_a = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) === null || _a === void 0 ? void 0 : _a.executor) === null || _b === void 0 ? void 0 : _b.name), operatorName = _f[0], setOperatorName = _f[1];
    (0, react_1.useEffect)(function () {
        if (!socketService)
            return;
        var eventListener = {
            'join response': function (data) {
                var _a;
                data && setOperatorName((_a = data.executor) === null || _a === void 0 ? void 0 : _a.name);
            },
        };
        socketService.addEventListener(eventListener);
        return function () { return socketService.removeEventListener(eventListener); };
    }, [socketService]);
    var redirectState = (widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.blocks.includes('knowledge')) && common_1.WIDGET_STATE.KNOWLEDGE_BASE;
    var avatar = ((_d = (_c = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) === null || _c === void 0 ? void 0 : _c.executor) === null || _d === void 0 ? void 0 : _d.image_url) || defaultAvatar_png_1.default;
    return ((0, jsx_runtime_1.jsx)(components_1.Header, __assign({ redirectState: redirectState, redirectText: intl.formatMessage({ id: 'back' }), className: styles.chatHeaderContainer, classNameRedirect: styles.chatHeaderRedirect }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.avatarContainer }, { children: [(0, jsx_runtime_1.jsx)("img", { src: avatar, alt: 'avatar', className: styles.avatar, draggable: 'false' }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: styles.name }, { children: operatorName || intl.formatMessage({ id: 'operator' }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.onlineStatusContainer }, { children: [(0, jsx_runtime_1.jsx)("div", { className: styles.onlineCircle }), (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.onlineText }, { children: intl.formatMessage({ id: 'onlineStatus' }) }))] }))] })] })) })));
};
exports.ChatHeader = ChatHeader;
